import React, { useState } from 'react';
import { FaWhatsapp, FaTelegram, FaUsers, FaFire, FaDumbbell, FaTrophy, FaComments, FaYoutube, FaInstagram } from 'react-icons/fa';

const Community = ({ YOUTUBE_CHANNEL, INSTAGRAM_PROFILE }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    goal: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleWhatsAppJoin = (e) => {
    e.preventDefault();
    const whatsappGroupLink = 'https://chat.whatsapp.com/CAsrkjCEANc4f9unrUxkn0';
    
    if (formData.name && formData.phone && formData.goal) {
      // Direct to WhatsApp group
      window.open(whatsappGroupLink, '_blank');
    } else {
      alert('Please fill all fields to join the community!');
    }
  };

  const handleTelegramJoin = () => {
    // You can add your Telegram link here when you create one
    alert('Telegram channel coming soon! Join our WhatsApp community for now.');
  };

  return (
    <div className="min-h-screen bg-black py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600 rounded-2xl p-1 mb-8 sm:mb-12">
          <div className="bg-black rounded-2xl p-6 sm:p-8 lg:p-12 text-center">
            <div className="flex justify-center mb-6">
              <div className="bg-gradient-to-r from-yellow-500 to-orange-600 p-6 rounded-full border-4 border-yellow-400">
                <FaUsers className="text-black text-5xl" />
              </div>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-yellow-400 uppercase tracking-wide mb-3 sm:mb-4">
              Join Our Fitness Community
            </h1>
            <p className="text-gray-300 text-base sm:text-lg lg:text-xl mb-4 sm:mb-6 max-w-3xl mx-auto">
              Connect with 500+ fitness enthusiasts, get daily motivation, share your progress, 
              and transform together with Coach Sabari's Rugged Fitness Community!
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-gray-900 border-2 border-yellow-500/50 rounded-xl p-4">
                <div className="text-3xl font-bold text-yellow-400">500+</div>
                <div className="text-gray-400 text-sm">Active Members</div>
              </div>
              <div className="bg-gray-900 border-2 border-orange-500/50 rounded-xl p-4">
                <div className="text-3xl font-bold text-orange-400">24/7</div>
                <div className="text-gray-400 text-sm">Support</div>
              </div>
              <div className="bg-gray-900 border-2 border-red-500/50 rounded-xl p-4">
                <div className="text-3xl font-bold text-red-400">100%</div>
                <div className="text-gray-400 text-sm">Free</div>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12">
          {[
            {
              icon: FaFire,
              title: 'Daily Motivation',
              description: 'Get inspired with daily fitness tips and motivational content',
              color: 'yellow'
            },
            {
              icon: FaDumbbell,
              title: 'Workout Tips',
              description: 'Learn new exercises and training techniques from experts',
              color: 'orange'
            },
            {
              icon: FaTrophy,
              title: 'Share Progress',
              description: 'Celebrate your wins and inspire others with your journey',
              color: 'red'
            },
            {
              icon: FaComments,
              title: 'Ask Questions',
              description: 'Get answers from Coach Sabari and experienced members',
              color: 'yellow'
            }
          ].map((benefit, index) => (
            <div
              key={index}
              className={`bg-gray-900 border-2 border-${benefit.color}-500/50 rounded-xl p-6 hover:border-${benefit.color}-400 transition-all transform hover:scale-105`}
            >
              <div className={`bg-gradient-to-r from-${benefit.color}-500 to-${benefit.color}-600 w-16 h-16 rounded-lg flex items-center justify-center mb-4`}>
                <benefit.icon className="text-black text-2xl" />
              </div>
              <h3 className={`text-xl font-bold text-${benefit.color}-400 uppercase mb-2`}>
                {benefit.title}
              </h3>
              <p className="text-gray-400 text-sm">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Join Form Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* WhatsApp Community */}
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-1">
            <div className="bg-black rounded-2xl p-6 sm:p-8">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-green-500 p-4 rounded-full">
                  <FaWhatsapp className="text-white text-4xl" />
                </div>
              </div>
              <h2 className="text-xl sm:text-2xl font-bold text-green-400 uppercase tracking-wide mb-3 sm:mb-4 text-center">
                WhatsApp Community
              </h2>
              <p className="text-gray-400 text-sm sm:text-base text-center mb-4 sm:mb-6">
                Join our active WhatsApp group for instant updates, daily tips, and community support!
              </p>

              <form onSubmit={handleWhatsAppJoin} className="space-y-4">
                <div>
                  <label className="block text-gray-400 font-semibold mb-2 text-sm uppercase">
                    Your Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your name"
                    className="w-full px-4 py-3 bg-gray-900 border-2 border-gray-700 rounded-lg text-white focus:outline-none focus:border-green-400 transition-all"
                  />
                </div>

                <div>
                  <label className="block text-gray-400 font-semibold mb-2 text-sm uppercase">
                    WhatsApp Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="+91 6383767287"
                    className="w-full px-4 py-3 bg-gray-900 border-2 border-gray-700 rounded-lg text-white focus:outline-none focus:border-green-400 transition-all"
                  />
                </div>

                <div>
                  <label className="block text-gray-400 font-semibold mb-2 text-sm uppercase">
                    Fitness Goal *
                  </label>
                  <select
                    name="goal"
                    value={formData.goal}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-gray-900 border-2 border-gray-700 rounded-lg text-white focus:outline-none focus:border-green-400 transition-all"
                  >
                    <option value="">Select your goal</option>
                    <option value="Weight Loss">Weight Loss</option>
                    <option value="Muscle Gain">Muscle Gain</option>
                    <option value="Strength Training">Strength Training</option>
                    <option value="General Fitness">General Fitness</option>
                  </select>
                </div>

                <button
                  type="submit"
                  className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 rounded-lg uppercase tracking-wide transition-all transform hover:scale-105 flex items-center justify-center space-x-2 border-2 border-green-400"
                >
                  <FaWhatsapp size={24} />
                  <span>Join WhatsApp Group</span>
                </button>
              </form>

              <div className="mt-4 text-center">
                <p className="text-gray-400 text-sm mb-3">Or join directly:</p>
                <a
                  href="https://chat.whatsapp.com/CAsrkjCEANc4f9unrUxkn0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 bg-gray-800 hover:bg-gray-700 text-green-400 px-6 py-3 rounded-lg font-bold transition-all border border-green-500/30"
                >
                  <FaWhatsapp size={20} />
                  <span>Quick Join Link</span>
                </a>
              </div>

              <div className="mt-6 p-4 bg-green-900/30 border border-green-500/30 rounded-lg">
                <p className="text-green-300 text-sm text-center">
                  ✓ Instant access • ✓ Daily updates • ✓ Free forever
                </p>
              </div>
            </div>
          </div>

          {/* Telegram Community */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl p-1">
            <div className="bg-black rounded-2xl p-6 sm:p-8">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-blue-500 p-4 rounded-full">
                  <FaTelegram className="text-white text-4xl" />
                </div>
              </div>
              <h2 className="text-xl sm:text-2xl font-bold text-blue-400 uppercase tracking-wide mb-3 sm:mb-4 text-center">
                Telegram Channel
              </h2>
              <p className="text-gray-400 text-sm sm:text-base text-center mb-4 sm:mb-6">
                Subscribe to our Telegram channel for exclusive content, workout videos, and nutrition tips!
              </p>

              <div className="space-y-4 mb-6">
                <div className="bg-gray-900 border border-gray-700 rounded-lg p-4">
                  <div className="flex items-center space-x-3">
                    <div className="text-2xl">📹</div>
                    <div>
                      <div className="text-white font-bold">Exclusive Videos</div>
                      <div className="text-gray-400 text-sm">Premium workout content</div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-900 border border-gray-700 rounded-lg p-4">
                  <div className="flex items-center space-x-3">
                    <div className="text-2xl">🥗</div>
                    <div>
                      <div className="text-white font-bold">Meal Plans</div>
                      <div className="text-gray-400 text-sm">Weekly nutrition guides</div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-900 border border-gray-700 rounded-lg p-4">
                  <div className="flex items-center space-x-3">
                    <div className="text-2xl">💪</div>
                    <div>
                      <div className="text-white font-bold">Live Sessions</div>
                      <div className="text-gray-400 text-sm">Q&A with Coach Sabari</div>
                    </div>
                  </div>
                </div>
              </div>

              <button
                onClick={handleTelegramJoin}
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-4 rounded-lg uppercase tracking-wide transition-all transform hover:scale-105 flex items-center justify-center space-x-2 border-2 border-blue-400"
              >
                <FaTelegram size={24} />
                <span>Join Telegram Channel</span>
              </button>

              <div className="mt-6 p-4 bg-blue-900/30 border border-blue-500/30 rounded-lg">
                <p className="text-blue-300 text-sm text-center">
                  ✓ No spam • ✓ Quality content • ✓ Expert guidance
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600 rounded-2xl p-1">
          <div className="bg-black rounded-2xl p-6 sm:p-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-yellow-400 uppercase tracking-wide mb-4 sm:mb-6 text-center">
              Follow on Social Media
            </h2>
            <p className="text-gray-400 text-sm sm:text-base text-center mb-6 sm:mb-8">
              Stay connected and get daily fitness inspiration
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* YouTube */}
              <a
                href={YOUTUBE_CHANNEL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-900 border-2 border-red-500/50 rounded-xl p-6 hover:border-red-400 transition-all transform hover:scale-105 group"
              >
                <div className="flex items-center space-x-4">
                  <div className="bg-red-600 p-4 rounded-lg group-hover:scale-110 transition-all">
                    <FaYoutube className="text-white text-3xl" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-red-400 uppercase mb-1">YouTube</h3>
                    <p className="text-gray-400 text-sm mb-2">80+ Workout Videos</p>
                    <div className="text-white font-bold">380+ Subscribers</div>
                  </div>
                </div>
              </a>

              {/* Instagram */}
              <a
                href={INSTAGRAM_PROFILE}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-900 border-2 border-pink-500/50 rounded-xl p-6 hover:border-pink-400 transition-all transform hover:scale-105 group"
              >
                <div className="flex items-center space-x-4">
                  <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-4 rounded-lg group-hover:scale-110 transition-all">
                    <FaInstagram className="text-white text-3xl" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-pink-400 uppercase mb-1">Instagram</h3>
                    <p className="text-gray-400 text-sm mb-2">Daily Fitness Posts</p>
                    <div className="text-white font-bold">Follow for Updates</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Community Rules */}
        <div className="mt-8 sm:mt-12 bg-gray-900 border-2 border-yellow-500/30 rounded-2xl p-6 sm:p-8">
          <h3 className="text-xl sm:text-2xl font-bold text-yellow-400 uppercase tracking-wide mb-4 sm:mb-6 text-center">
            Community Guidelines
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <span className="text-green-400 text-xl">✓</span>
                <p className="text-gray-400 text-sm">Be respectful and supportive to all members</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-green-400 text-xl">✓</span>
                <p className="text-gray-400 text-sm">Share your progress and celebrate others' wins</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-green-400 text-xl">✓</span>
                <p className="text-gray-400 text-sm">Ask questions and help others when you can</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-green-400 text-xl">✓</span>
                <p className="text-gray-400 text-sm">Stay motivated and inspire the community</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <span className="text-red-400 text-xl">✗</span>
                <p className="text-gray-400 text-sm">No spam or promotional content</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-red-400 text-xl">✗</span>
                <p className="text-gray-400 text-sm">No negative or discouraging comments</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-red-400 text-xl">✗</span>
                <p className="text-gray-400 text-sm">No sharing of personal information</p>
              </div>
              <div className="flex items-start space-x-3">
                <span className="text-red-400 text-xl">✗</span>
                <p className="text-gray-400 text-sm">No off-topic discussions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Community;
